const GearIcon = () => {
    return (
        <img src="../svgs/Actions.svg" alt="gear" />
    )
}

export default GearIcon;